import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=0861af5c&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=0861af5c&prod&lang=less&scoped=true"
import style1 from "./plan-detail.vue?vue&type=style&index=1&id=0861af5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861af5c",
  null
  
)

export default component.exports